import React, { useEffect } from 'react'
import { Autosuggest, Button, Cell, FilterChips, Grid, useChipCollection } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { actions } from './useDatsJobs'

export default () => {}

export function DatsJobsFilters({ datsJobsState, datsJobsFunctions, setOpen }) {
  const { t } = useTranslation()
  const chipCollection = useChipCollection(datsJobsState.filtersOptions.jobStatusOptions)

  useEffect(() => {
    const action = {
      type: actions.SET_FILTER_STATUS_LIST,
      payload: chipCollection.selectedChips,
    }
    datsJobsFunctions.dispatch(action)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chipCollection.selectedChips])

  function dispatchAction(payload, actionType) {
    const action = {
      type: actionType,
      payload,
    }
    datsJobsFunctions.dispatch(action)
  }

  function clearFilters() {
    chipCollection.chips.forEach((chip) => {
      chip.selected = false
    })
    dispatchAction(datsJobsState.currentUser, actions.SET_CURRENT_USER)
    dispatchAction(null, actions.CLEAR_FILTERS)
  }

  function autosuggestSort(inputValue, suggestionA, suggestionB) {
    if (suggestionA?.group == null || suggestionB?.group == null) {
      return suggestionA.primaryText.localeCompare(suggestionB.primaryText)
    }
    const groupSort = suggestionA.group.localeCompare(suggestionB.group)
    if (groupSort === 0) {
      return suggestionA.primaryText.localeCompare(suggestionB.primaryText)
    }
    return groupSort
  }

  function getToolsSuggestions() {
    return datsJobsState.filtersOptions.toolNameOptions.filter((tool) => {
      const toolGroup = datsJobsState?.filters?.groupSelectedItem?.primaryText
      return toolGroup ? tool.group === toolGroup : true
    })
  }

  return (
    <Grid>
      <Grid columns={10} gutters="xxs">
        {/* Row */}
        <Cell columns={4} gutters="xxs">
          <div data-testid="datsJobsCisIdAutosuggest">
            <Autosuggest
              label={t('dats.createBy', 'Created by')}
              selectedItem={datsJobsState.filters.cisIdSelectedItem}
              suggestions={datsJobsState.filtersOptions.cisIdOptions}
              onSuggestionSelected={(selection) => selection && dispatchAction(selection, actions.SET_FILTER_CIS_ID)}
              onClear={() => dispatchAction(null, actions.SET_FILTER_CIS_ID)}
              placeholder={t('dats.typeCisId', 'Type a Cis ID')}
              handleInput
              highlightMatchingText
              clearable
              clearOnClickAway
              sortFunction={autosuggestSort}
            />
          </div>
        </Cell>
        <Cell columns={3}>
          <div data-testid="datsJobsToolGroupsAutosuggest">
            <Autosuggest
              key={`toolGroupAutosuggest-${datsJobsState.filters.groupSelectedItem?.primaryText}`}
              label={t('dats.toolGroup', 'Tool Group')}
              selectedItem={datsJobsState.filters.groupSelectedItem}
              suggestions={datsJobsState.filtersOptions.toolGroupOptions}
              onSuggestionSelected={(selection) =>
                selection && dispatchAction(selection, actions.SET_FILTER_GROUP_NAME)
              }
              onClear={() => dispatchAction(undefined, actions.SET_FILTER_GROUP_NAME)}
              placeholder={t('dats.selectAToolGroup', 'Select a Tool Group')}
              highlightMatchingText
              clearable
              clearOnClickAway
              sortFunction={autosuggestSort}
            />
          </div>
        </Cell>

        <Cell columns={3}>
          <div data-testid="datsJobsToolNamesAutosuggest">
            <Autosuggest
              key={`toolNameAutosuggest-${datsJobsState.filters.toolSelectedItem?.primaryText}`}
              label={t('dats.tool', 'Tool')}
              selectedItem={datsJobsState.filters.toolSelectedItem}
              suggestions={getToolsSuggestions()}
              onSuggestionSelected={(selection) => selection && dispatchAction(selection, actions.SET_FILTER_TOOL_NAME)}
              onClear={() => dispatchAction(undefined, actions.SET_FILTER_TOOL_NAME)}
              placeholder={t('dats.selectATool', 'Select a Tool')}
              highlightMatchingText
              clearable
              clearOnClickAway
              sortFunction={autosuggestSort}
            />
          </div>
        </Cell>
        {/* Row */}
        <Cell columns={12}>
          <FilterChips
            data-testid="datsJobsStatusChips"
            label={t('dats.jobStatus', 'Job Status')}
            chipCollection={chipCollection}
          />
        </Cell>
      </Grid>
      <Grid columns={2} gutters="xxs">
        <Cell columns={2}>
          <Button
            data-testid="datsJobsGetJobsButton"
            onClick={() => {
              setOpen(false)
              datsJobsFunctions.getTableFiltered()
            }}
          >
            {t('dats.getJobs', 'Apply Filters')}
          </Button>
        </Cell>
        <Cell columns={2}>
          <Button data-testid="datsJobsClearFiltersButton" onClick={() => clearFilters()}>
            {t('filters.reset', 'Reset Filters')}
          </Button>
        </Cell>
      </Grid>
    </Grid>
  )
}
